import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function over(event) {
  return true;
}
function enter(event) {
  return true;
}
function exit(event) {
  return true;
}
function end(event) {
  return true;
}
var DropTargetDelegateClass;
function DropTargetDelegate() {
  if (DropTargetDelegateClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'DropTargetDelegate');
    DropTargetDelegateClass = $;
  }
  return DropTargetDelegateClass;
}
//region block: exports
export {
  exit as exit1izku02sy8o8o,
  over as over39z80ikqtn4zd,
  DropTargetDelegate as DropTargetDelegatej7xcw0yh1xmk,
};
//endregion

//# sourceMappingURL=DropTargetDelegate.mjs.map
